var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dish-group-manage-container" }, [
    _c(
      "div",
      { staticClass: "radio-group-container" },
      [
        _c(
          "el-radio-group",
          {
            on: { change: _vm.handleTabChange },
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          [
            _c("el-radio-button", { attrs: { label: "firstCategory" } }, [
              _vm._v("一级分类目录"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "secondCategory" } }, [
              _vm._v("二级分类目录"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "dishGroup" } }, [
              _vm._v("小程序菜品分组"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "batchOperation" } }, [
              _vm._v("批量操作"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "primaryMenu" } }, [
              _vm._v("一级菜单"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "component-container" },
      [
        _vm.activeTab === "dishGroup"
          ? _c("dish-group-manage", { ref: "dishGroupRef" })
          : _vm._e(),
        _vm._v(" "),
        _vm.activeTab === "primaryMenu"
          ? _c("primary-menu-manage", { ref: "primaryMenuRef" })
          : _vm._e(),
        _vm._v(" "),
        _vm.activeTab === "firstCategory"
          ? _c("category-manage", {
              ref: "categoryRef",
              on: { showSecondCategory: _vm.handleShowSecondCategory },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.activeTab === "secondCategory"
          ? _c("second-category-list", {
              key: _vm.selectedParent
                ? "second-" + _vm.selectedParent.id
                : "second-all",
              ref: "secondCategoryRef",
              attrs: {
                "parent-id": _vm.selectedParent ? _vm.selectedParent.id : null,
                "parent-category": _vm.selectedParent,
              },
              on: { clearParent: _vm.handleClearParent },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.activeTab === "batchOperation"
          ? _c("dish-group-batch", { ref: "dishGroupBatchRef" })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }